import React from "react"
import { OBJECAO_FONTE, OBJECAO_FONTE_LABEL, OBJECAO_NUMERO } from "../../lib/narrativa"

// Ícone de raio (velocidade/atalho) — marca cada ponto em dourado.
function Bolt({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M13 2 4.5 13.5H11l-1 8.5L19.5 10H13l0-8z" />
    </svg>
  )
}

const POINTS: [string, string][] = [
  ["Fixa testando, não relendo", "Cada questão que você tenta responder crava o conteúdo muito mais do que reler a mesma página."],
  ["Treina só o que a banca cobra", "O livro tem o assunto inteiro; a prova cobra um recorte. A questão te leva direto nele."],
  ["Acha seus buracos na hora", "Errou? Já sabe o que revisar hoje — em vez de descobrir no dia da prova."],
]

/**
 * Bloco de persuasão: por que estudar resolvendo questões acelera muito mais do
 * que só ler teoria (efeito de testagem). Copy única, usada na página de
 * boas-vindas e no estado inicial da página da prova.
 */
export function WhyQuestions() {
  return (
    <section aria-label="Por que estudar por questões">
      <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
        <p className="font-display text-xs font-bold uppercase tracking-[0.22em] text-gold-600">Estude com método</p>
        <h2 className="mt-1.5 font-display text-2xl font-bold uppercase leading-tight tracking-tight text-navy-900 sm:text-3xl">
          O atalho que funciona em prova objetiva
        </h2>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-navy-600">
          Você não precisa estudar a apostila inteira antes de fazer questões — é o contrário. Em prova objetiva, o
          caminho mais curto é descobrir primeiro <span className="font-semibold text-navy-800">o que te derrubaria</span>{" "}
          e estudar só isso.
        </p>
        <p className="mt-2 max-w-2xl text-sm leading-relaxed text-navy-500">
          Não é palpite: {OBJECAO_NUMERO} (
          <a href={OBJECAO_FONTE} className="underline" target="_blank" rel="noopener">
            {OBJECAO_FONTE_LABEL}
          </a>
          , replicado em quatro experimentos).
        </p>

        <ul className="mt-5 grid gap-4 sm:grid-cols-3">
          {POINTS.map(([title, text]) => (
            <li key={title} className="flex flex-col gap-1.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-gold-400/15">
                <Bolt className="h-5 w-5 text-gold-600" />
              </span>
              <span className="mt-1 font-semibold text-navy-900">{title}</span>
              <span className="text-sm leading-relaxed text-navy-600">{text}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}
